import { AnimatePresence, motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Pencil } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { editStatusProspect } from "../../../slices/prospectSlice";

export default function ModalViewProspect({
  isModalOpen,
  setIsModalOpen,
  prospect,
  setIsModalEdit,
  handleEditStatus,
}) {
  const { loading, error } = useSelector((state) => state.prospectos);

  const handleModalEdit = () => {
    setIsModalOpen(false);
    setIsModalEdit(true);
  };

  return (
    <AnimatePresence>
      {isModalOpen && (
        <motion.div
          key="modal-background"
          onClick={() => setIsModalOpen(false)}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
          <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-xl shadow-2xl p-8 font-poppins w-[500px] mx-4 "
          >
            
            <div className="flex justify-between items-center mb-8">
              <h3 className="text-2xl font-bold text-text">
                Información del Prospecto
              </h3>
              <div className="flex items-center space-x-4">
                <button
                  onClick={handleModalEdit}
                  className="p-2 rounded-full hover:bg-gray-100 transition-colors"
                >
                  <Pencil className="w-5 h-5 text-gray-500" />
                </button>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="p-2 rounded-full hover:bg-gray-100 transition-colors"
                >
                  <XMarkIcon className="w-6 h-6 text-gray-500" />
                </button>
              </div>
            </div>

           
            <div className="space-y-6">
             
              <div className="flex flex-col space-y-2">
                <span className="text-sm font-medium text-text">Nombre</span>
                <span className="text-subtitle font-semibold">
                  {prospect.name || "Desconocido"}
                </span>
              </div>

           
              <div className="flex flex-col space-y-2">
                <span className="text-sm font-medium text-text">Email</span>
                <span className="text-subtitle font-semibold">
                  {prospect.email || "N/A"}
                </span>
              </div>

            
              <div className="flex flex-col space-y-2">
                <span className="text-sm font-medium text-text">Teléfono</span>
                <span className="text-subtitle font-semibold">
                  {prospect.phone ? `+${prospect.phone}` : "N/A"}
                </span>
              </div>

              {/* Campo: Descripción */}
              <div className="flex flex-col space-y-2">
                <span className="text-sm font-medium text-text">Descripción</span>
                <span className="text-subtitle font-semibold">
                  {prospect.description || "Sin descripción"}
                </span>
              </div>

              {/* Campo: Nueva Idea */}
              <div className="flex flex-col space-y-2">
                <span className="text-sm font-medium text-text">Nueva Idea</span>
                <span className="text-subtitle font-semibold">
                  {prospect.newIdea ? "Sí" : "No"}
                </span>
              </div>

              {/* Campo: Podcast */}
              <div className="flex flex-col space-y-2">
                <span className="text-sm font-medium text-text">Podcast</span>
                <span className="text-subtitle font-semibold">
                  {prospect.namePodcast || "Sin podcast"}
                </span>
              </div>
            </div>

            {/* Botones de acción */}
            {prospect.status !== "Approved" && (
              <div className="mt-8 flex justify-end space-x-4">
                <button
                  onClick={() => handleEditStatus(prospect._id, "Rejected")}
                  className="px-6 py-2 text-sm font-semibold text-red-600 rounded-lg border border-red-200 hover:bg-red-50 transition-colors"
                >
                  {loading ? "Cargando..." : "Rechazar"}
                </button>
                <button
                  onClick={() => handleEditStatus(prospect._id, "Approved")}
                  className="px-6 py-2 text-sm font-semibold text-green-600 rounded-lg border border-green-200 hover:bg-green-50 transition-colors"
                >
                  {loading ? "Cargando..." : "Aceptar"}
                </button>
              </div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}